import Handsontable from 'handsontable';
import { isEqual } from 'lodash';
import { asObject } from '../../../../../../common/utils/immutableHelper';
import { CellSelections } from '../../../../../../common/table/TableTypes';
import { getEndCol, getEndRow, getStartCol, getStartRow } from '../../selectionUtils/tableSelectionAccessors';
import { isSelectingRefColHeader, isSelectingRefRowHeader } from '../../selectionUtils/tableSelectionPredicateUtils';
import { setTransactionIdForNextUpdateCellSelection } from './_hotTableSelectionTransactionUtils';

/**
 * Moves the cell selections in the Handsontable instance to match the provided selections.
 */
export const updateHotTableCellSelections = (
    hotInstance: Handsontable | null | undefined,
    cellSelections: CellSelections,
    transactionId?: number,
) => {
    if (!hotInstance) return;

    hotInstance.deselectCell();

    if (!cellSelections) return;

    // TODO-TABLES - Not sure why this asObject conversion is needed, but keeping it for now to avoid breaking changes
    const newCellSelections = asObject(cellSelections) as CellSelections;

    const currentHotCellSelections = hotInstance.getSelected();
    if (isEqual(newCellSelections, currentHotCellSelections)) return;

    setTransactionIdForNextUpdateCellSelection(hotInstance, transactionId);

    const selectingRefColHeader = newCellSelections.find(isSelectingRefColHeader);
    if (selectingRefColHeader) {
        hotInstance.selectColumns(
            Math.max(getStartCol(selectingRefColHeader), 0),
            Math.min(getEndCol(selectingRefColHeader), hotInstance.countCols() - 1),
        );
        return;
    }

    const selectingRefRowHeader = newCellSelections.find(isSelectingRefRowHeader);
    if (selectingRefRowHeader) {
        hotInstance.selectRows(
            Math.max(getStartRow(selectingRefRowHeader), 0),
            Math.min(getEndRow(selectingRefRowHeader), hotInstance.countRows() - 1),
        );
        return;
    }

    hotInstance.selectCells(newCellSelections);
};
